import ModalTemplate, {modalPageDecorator} from "./ModalTemplate";

export default modalPageDecorator({
  render(h) {
    return (
      <ModalTemplate>
        <div class="m-2 lg:my-12">
          <div class="bg-white container md:max-w-3xl mx-auto rounded shadow-lg relative z-50 overflow-hidden">
            <div class="p-5 pb-10">
              <div onClick={this.dismiss} class="cursor-pointer z-50">
                <i class="mdi mdi-close text-3xl lg:text-4xl leading-none"></i>
              </div>
              <div class="text-center">
                <h3 class="text-3xl">
                  {this.$t('contact_modal.thank_you')}
                </h3>
                <p class="text-xl lg:px-5 my-4 font-normal">
                  {this.$t('contact_modal.response_message')}
                </p>
                <button onClick={this.dismiss}
                  class="flex-shrink-0 lg:mr-8 mb-3 lg:mb-0 px-5 p-2 lg:p-3 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline text-lg"
                  type="button">
                  {this.$t('continue_')}
                  <i class="mdi mdi-arrow-right ml-5"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ModalTemplate>
    )
  }
})